import uiRouter from 'angular-ui-router';

import creditRequestConfig from './credit-request.config';
import creditRequestComponent from './credit-request.component';

import creditRequestShared from './shared/';

export default angular.module('webPublicClient.creditRequest', [
  uiRouter,
  creditRequestShared.name
])
.config(creditRequestConfig)
.component('creditRequest', creditRequestComponent);



// WEBPACK FOOTER //
// ./src/credit-request/index.js